<template>
    <section>
        <div id="loading" v-if="show">
            <div class="wrapper">
                <loader v-bind:loading="true" v-bind:color="'#fff'" v-bind:size="'100px'"></loader>
            </div>
        </div>
    </section>
</template>

<script>
    import Loader from 'vue-spinner/src/RingLoader.vue';
    /**
     * @param {Boolean} show 
     */
    export default {
        name: "Loading",
        components: {
            "loader": Loader
        },
        props: ['show']
    };
</script>

<style scoped>
    #loading { 
        position: fixed; 
        top: 0; 
        right: 0; 
        bottom: 0; 
        left: 0; 
        z-index: 1080;
        background-color: transparent;
        background-color: #000000b3;
        background-color: rgba(0, 0, 0, 0.7);
        text-align: center;
    }
    #loading .wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>


// WEBPACK FOOTER //
// src/components/item/Loading.vue